import {useCallback} from 'react';
import {Concept} from 'types';
import type {ViewMode} from 'services/advancedSearch/types';
import {useSetAdvancedSearchViewMode} from 'services/advancedSearchViewMode';
import {selectAdvancedSearchViewMode} from 'services/advancedSearchViewMode/reducer';
import {useAppSelector} from 'store/hooks';
import type {CurrentColumnsType, ViewModeType} from '../types';

export const useViewMode = ({
  updateCurrentColumns,
}: Pick<CurrentColumnsType, 'updateCurrentColumns'>): ViewModeType => {
  const viewMode = useAppSelector(selectAdvancedSearchViewMode);
  const setViewMode = useSetAdvancedSearchViewMode();

  const handleViewModeChange = useCallback(
    (viewMode: ViewMode) => {
      // The id column of the view mode replaces the id column of the other,
      // both toggled in a single update.
      updateCurrentColumns([
        {name: 'workId', visible: viewMode === Concept.work},
        {name: 'ean', visible: viewMode === Concept.manifestation},
      ]);

      setViewMode(viewMode);
    },
    [setViewMode, updateCurrentColumns],
  );

  return {
    viewMode,
    setViewMode: handleViewModeChange,
  };
};
